/* RubyGator pre-orders and "Max per klant".
   - When the cart refuses more units of a pre-order product, the theme's error dialog shows the
     pre-order message (data-rg-po-limit) instead of the generic text.
   - Pre-order consent in the cart (snippets/rg-po-consent.liquid) must be ticked before checkout.
   - Products with a maximum per customer (data-rg-limit, from snippets/rg-limit.liquid) can't go over
     that maximum in the cart: adding more is refused, raising the quantity in the cart is capped. */
(function () {
  var last = null;
  var limitHit = null;
  var en = (document.documentElement.lang || '').indexOf('en') === 0;
  var SCOPES = '.bls__product-item, .bls__product-details-infor, .bls__product-quickview, .dlg-box, .product-list-item';

  function limitFor(el) {
    var scope = el.closest(SCOPES);
    var holder = scope && scope.querySelector('[data-rg-po-limit]');
    // The sticky bar and other forms on a product page use the panel of the main product
    if (!holder && document.body.classList.contains('template-product')) {
      holder = document.querySelector('.rg-po-panel[data-rg-po-limit]');
    }
    return holder ? holder.getAttribute('data-rg-po-limit') : null;
  }

  function remember(event) {
    var el = event.target && event.target.closest ? event.target : null;
    if (!el) return;
    if (event.type === 'click' && !el.closest('button, [type="submit"]')) return;
    var msg = limitFor(el);
    last = msg ? { msg: msg, at: Date.now() } : null;
  }

  document.addEventListener('click', remember, true);
  document.addEventListener('submit', remember, true);

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function patch() {
    if (!window.EasyDialogBox || EasyDialogBox.rgPreorder) return;
    var create = EasyDialogBox.create;
    EasyDialogBox.create = function (id, cls, title, message) {
      if (id === 'add_cart_error' && limitHit && Date.now() - limitHit.at < 10000) {
        var limitArgs = Array.prototype.slice.call(arguments);
        limitArgs[3] = limitHtml(limitHit.msg);
        limitHit = null;
        return create.apply(this, limitArgs);
      }
      if (id === 'add_cart_error' && last && Date.now() - last.at < 20000) {
        message =
          '<div class="rg-po-dialog"><p class="rg-po-dialog__title">' +
          (en ? 'Pre-order limit reached' : 'Pre-order limiet bereikt') +
          '</p><p class="rg-po-dialog__text">' + escapeHtml(last.msg) + '</p></div>';
        var args = Array.prototype.slice.call(arguments);
        args[3] = message;
        return create.apply(this, args);
      }
      return create.apply(this, arguments);
    };
    EasyDialogBox.rgPreorder = true;
  }

  // "Zo werkt een pre-order" modal. Without <dialog> support the link simply opens the pre-orders page.
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var opener = target.closest('[data-rg-po-open]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('data-rg-po-open'));
      if (dialog && typeof dialog.showModal === 'function') {
        event.preventDefault();
        dialog.showModal();
      }
      return;
    }
    if (target.closest('[data-rg-po-close]')) {
      target.closest('dialog').close();
      return;
    }
    // A click on the dark backdrop lands on the dialog element itself
    if (target.tagName === 'DIALOG' && target.classList.contains('rg-po-modal')) target.close();
  });

  // Max per klant
  function limitHtml(msg) {
    return '<div class="rg-po-dialog"><p class="rg-po-dialog__title">' +
      (en ? 'Maximum per customer reached' : 'Maximum per klant bereikt') +
      '</p><p class="rg-po-dialog__text">' + escapeHtml(msg) + '</p></div>';
  }

  function limitRules() {
    var rules = {};
    document.querySelectorAll('script[data-rg-limit]').forEach(function (node) {
      try {
        var rule = JSON.parse(node.textContent);
        rule.variants.forEach(function (id) { rules[String(id)] = rule; });
      } catch (e) {}
    });
    return rules;
  }

  function inCart(cart, rule) {
    return cart.items.reduce(function (sum, item) {
      return rule.variants.indexOf(item.variant_id) > -1 ? sum + item.quantity : sum;
    }, 0);
  }

  function limitMessage(rule, cartQty) {
    if (rule.left <= 0) {
      return en
        ? 'You have already ordered the maximum of ' + rule.max + ' of this product.'
        : 'Je hebt het maximum van ' + rule.max + ' stuks van dit product al besteld.';
    }
    var text = en
      ? 'You can order up to ' + rule.max + ' of this product per customer.'
      : 'Van dit product kun je maximaal ' + rule.max + ' per klant bestellen.';
    if (rule.bought > 0) text += en ? ' You have already ordered ' + rule.bought + '.' : ' Je hebt er al ' + rule.bought + ' besteld.';
    if (cartQty > 0) text += en ? ' Your cart already holds ' + cartQty + '.' : ' Er zitten er al ' + cartQty + ' in je winkelmand.';
    return text;
  }

  function refuse(msg) {
    limitHit = { msg: msg, at: Date.now() };
    var body = JSON.stringify({ status: 422, message: 'Cart Error', description: msg, errors: msg });
    return new Response(body, { status: 422, headers: { 'Content-Type': 'application/json' } });
  }

  function showNotice(msg) {
    if (!window.EasyDialogBox) return;
    var box = EasyDialogBox.create('rg_limit_notice', 'dlg dlg-disable-footer dlg-disable-drag dlg-disable-heading', '', limitHtml(msg));
    box.onClose = box.destroy;
    box.show();
  }

  // Items from an add request: product forms send FormData, quick add sends JSON
  function addedItems(body) {
    if (!body) return [];
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      return body.get('id') ? [{ id: body.get('id'), quantity: Number(body.get('quantity') || 1) }] : [];
    }
    if (typeof body === 'string') {
      try {
        var data = JSON.parse(body);
        if (data.items) return data.items.map(function (i) { return { id: i.id, quantity: Number(i.quantity || 1) }; });
        if (data.id) return [{ id: data.id, quantity: Number(data.quantity || 1) }];
      } catch (e) {
        var params = new URLSearchParams(body);
        if (params.get('id')) return [{ id: params.get('id'), quantity: Number(params.get('quantity') || 1) }];
      }
    }
    return [];
  }

  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = ((init && init.method) || 'GET').toUpperCase();
      var match = method === 'POST' && /\/cart\/(add|change)(\.js)?(\?|$)/.exec(url.replace(location.origin, ''));
      if (!match) return nativeFetch.apply(this, arguments);
      var rules = limitRules();
      if (!Object.keys(rules).length) return nativeFetch.apply(this, arguments);
      var self = this;
      var args = arguments;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

      return nativeFetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          if (match[1] === 'add') {
            var items = addedItems(init && init.body);
            for (var i = 0; i < items.length; i++) {
              var rule = rules[String(items[i].id)];
              if (!rule) continue;
              var qty = inCart(cart, rule);
              if (qty + items[i].quantity > rule.left) return refuse(limitMessage(rule, qty));
            }
            return nativeFetch.apply(self, args);
          }

          // Quantity change in the mini cart or on the cart page: cap it at the maximum
          var data;
          try { data = JSON.parse(init.body); } catch (e) { return nativeFetch.apply(self, args); }
          var line = null;
          if (data.line) line = cart.items[Number(data.line) - 1];
          else if (data.id) {
            line = cart.items.filter(function (item) {
              return String(data.id).indexOf(':') > -1 ? item.key === String(data.id) : String(item.variant_id) === String(data.id);
            })[0];
          }
          var lineRule = line && rules[String(line.variant_id)];
          if (!lineRule) return nativeFetch.apply(self, args);
          var others = inCart(cart, lineRule) - line.quantity;
          var allowed = Math.max(0, lineRule.left - others);
          if (Number(data.quantity) <= allowed) return nativeFetch.apply(self, args);
          data.quantity = allowed;
          var capped = Object.assign({}, init, { body: JSON.stringify(data) });
          return nativeFetch.call(self, input, capped).then(function (res) {
            setTimeout(function () { showNotice(limitMessage(lineRule, others)); }, 400);
            return res;
          });
        })
        .catch(function () { return nativeFetch.apply(self, args); });
    };
  }

  // The quantity field on the product page can't go above what's still allowed
  function capQuantityInputs() {
    var rules = limitRules();
    document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(function (form) {
      var id = form.querySelector('[name="id"]');
      var rule = id && rules[String(id.value)];
      if (!rule) return;
      var selector = 'input[name="quantity"][form="' + form.id + '"]';
      var inputs = Array.prototype.slice.call(document.querySelectorAll(selector)).concat(Array.prototype.slice.call(form.querySelectorAll('input[name="quantity"]')));
      inputs.forEach(function (input) {
        input.max = Math.max(1, rule.left);
      });
    });
  }

  // Pre-order consent in the cart: checkout waits until the box is ticked, the acceptance goes on the order
  var CONSENT_KEY = 'Pre-order voorwaarden';
  var consentSaving = null;
  var consentPassed = false;

  function saveConsent(checked) {
    var now = new Date();
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var stamp = pad(now.getDate()) + '-' + pad(now.getMonth() + 1) + '-' + now.getFullYear() + ' ' + pad(now.getHours()) + ':' + pad(now.getMinutes());
    var attributes = {};
    attributes[CONSENT_KEY] = checked ? (en ? 'Accepted on ' : 'Geaccepteerd op ') + stamp : '';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    consentSaving = nativeFetch(root + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).catch(function () {}).then(function () { consentSaving = null; });
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('[data-rg-po-consent-input]')) return;
    var box = input.closest('[data-rg-po-consent]');
    var error = box && box.querySelector('[data-rg-po-consent-error]');
    if (error && input.checked) error.hidden = true;
    if (box) box.classList.toggle('is-invalid', false);
    // Keep the mini cart and cart page in step
    document.querySelectorAll('[data-rg-po-consent-input]').forEach(function (other) { other.checked = input.checked; });
    saveConsent(input.checked);
  });

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest && event.target.closest('[name="checkout"], a[href$="/checkout"]');
    if (!button || consentPassed) return;
    var scope = button.closest('form, .bls-drawer-bottom, .cart__footer') || document;
    var box = scope.querySelector('[data-rg-po-consent]') || document.querySelector('[data-rg-po-consent]');
    if (!box) return;
    var input = box.querySelector('[data-rg-po-consent-input]');
    if (!input.checked) {
      event.preventDefault();
      event.stopImmediatePropagation();
      box.classList.add('is-invalid');
      box.querySelector('[data-rg-po-consent-error]').hidden = false;
      box.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      input.focus();
      return;
    }
    // Ticked just now: let the acceptance reach the cart before going to checkout
    if (consentSaving) {
      event.preventDefault();
      event.stopImmediatePropagation();
      consentSaving.then(function () {
        consentPassed = true;
        button.click();
        consentPassed = false;
      });
    }
  }, true);

  patch();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', capQuantityInputs);
  } else {
    capQuantityInputs();
  }
  if (!window.EasyDialogBox) {
    document.addEventListener('DOMContentLoaded', patch);
  }
})();
